import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import "./styles.css";

const NotFoundPage = () => {
  const navigator = useNavigate();

  const handleBack = () => {
    navigator(-1);
  };

  return (
    <>
      <div className="errorContainer">
        <div className="errorWrapper">
          <h1>404</h1>
          <h2>ERROR</h2>
          <Button
            onClick={(e) => {
              handleBack(e);
            }}
            text={
              <>
                Go Back<span aria-hidden></span>
                <span aria-hidden class="cybrBtnGlitch">
                  Go Back
                </span>
              </>
            }
          />
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
